const PERSIAN_LETTERS = [
  'ا', 'ب', 'پ', 'ت', 'ث', 'ج', 'چ', 'ح', 'خ', 'د', 'ذ', 'ر', 'ز', 'ژ', 'س', 'ش',
  'ص', 'ض', 'ط', 'ظ', 'ع', 'غ', 'ف', 'ق', 'ک', 'گ', 'ل', 'م', 'ن', 'و', 'ه', 'ی',
];

const ARABIC_LETTERS = [
  'ا', 'ب', 'ت', 'ث', 'ج', 'ح', 'خ', 'د', 'ذ', 'ر', 'ز', 'س', 'ش', 'ص', 'ض', 'ط',
  'ظ', 'ع', 'غ', 'ف', 'ق', 'ك', 'ل', 'م', 'ن', 'ه', 'و', 'ي',
];

const ENGLISH_LETTERS = 'abcdefghijklmnopqrstuvwxyz'.split('');

const CHINESE_LETTERS = [
  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
  ...ENGLISH_LETTERS,
];

const JAPANESE_LETTERS = [
  'あ', 'い', 'う', 'え', 'お',
  'か', 'き', 'く', 'け', 'こ',
  'さ', 'し', 'す', 'せ', 'そ',
  'た', 'ち', 'つ', 'て', 'と',
  'な', 'に', 'ぬ', 'ね', 'の',
  'は', 'ひ', 'ふ', 'へ', 'ほ',
  'ま', 'み', 'む', 'め', 'も',
  'や', 'ゆ', 'よ',
  'ら', 'り', 'る', 'れ', 'ろ',
  'わ', 'を', 'ん',
];

const HINDI_LETTERS = [
  'अ', 'आ', 'इ', 'ई', 'उ', 'ऊ', 'ए', 'ऐ', 'ओ', 'औ',
  'क', 'ख', 'ग', 'घ', 'ङ',
  'च', 'छ', 'ज', 'झ', 'ञ',
  'ट', 'ठ', 'ड', 'ढ', 'ण',
  'त', 'थ', 'द', 'ध', 'न',
  'प', 'फ', 'ब', 'भ', 'म',
  'य', 'र', 'ल', 'व',
  'श', 'ष', 'स', 'ह',
];

const KOREAN_LETTERS = [
  'ㄱ', 'ㄴ', 'ㄷ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅅ', 'ㅇ', 'ㅈ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ',
  'ㅏ', 'ㅑ', 'ㅓ', 'ㅕ', 'ㅗ', 'ㅛ', 'ㅜ', 'ㅠ', 'ㅡ', 'ㅣ',
];

const CYRILLIC_LETTERS = [
  'а', 'б', 'в', 'г', 'д', 'е', 'ё', 'ж', 'з', 'и', 'й', 'к', 'л', 'м', 'н', 'о',
  'п', 'р', 'с', 'т', 'у', 'ф', 'х', 'ц', 'ч', 'ш', 'щ', 'ъ', 'ы', 'ь', 'э', 'ю', 'я',
];

const THAI_LETTERS = [
  'ก', 'ข', 'ค', 'ฆ', 'ง', 'จ', 'ฉ', 'ช', 'ซ', 'ฌ', 'ญ',
  'ด', 'ต', 'ถ', 'ท', 'ธ', 'น', 'บ', 'ป', 'ผ', 'ฝ', 'พ', 'ฟ', 'ภ', 'ม',
  'ย', 'ร', 'ล', 'ว', 'ศ', 'ษ', 'ส', 'ห', 'อ', 'ฮ',
];

const HEBREW_LETTERS = [
  'א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ז', 'ח', 'ט', 'י', 'כ', 'ל', 'מ', 'נ', 'ס', 'ע', 'פ', 'צ', 'ק', 'ר', 'ש', 'ת',
];

const GREEK_LETTERS = [
  'α', 'β', 'γ', 'δ', 'ε', 'ζ', 'η', 'θ', 'ι', 'κ', 'λ', 'μ', 'ν', 'ξ', 'ο', 'π', 'ρ', 'σ', 'τ', 'υ', 'φ', 'χ', 'ψ', 'ω',
];

const BENGALI_LETTERS = [
  'অ', 'আ', 'ই', 'ঈ', 'উ', 'ঊ', 'এ', 'ঐ', 'ও', 'ঔ',
  'ক', 'খ', 'গ', 'ঘ', 'ঙ', 'চ', 'ছ', 'জ', 'ঝ', 'ঞ',
  'ট', 'ঠ', 'ড', 'ঢ', 'ণ', 'ত', 'থ', 'দ', 'ধ', 'ন',
  'প', 'ফ', 'ব', 'ভ', 'ম', 'য', 'র', 'ল', 'শ', 'ষ', 'স', 'হ',
];

const LATIN_LANGUAGE_CODES = new Set([
  'en', 'de', 'fr', 'es', 'tr', 'pt', 'it', 'nl', 'pl', 'sv', 'da', 'no', 'fi',
  'cs', 'ro', 'hu', 'id', 'ms', 'vi', 'tl', 'sw', 'ca', 'sk', 'hr', 'sl',
  'lt', 'lv', 'et', 'sq', 'az', 'uz', 'hy',
]);

const ALPHABETS: Record<string, string[]> = {
  fa: PERSIAN_LETTERS,
  ps: PERSIAN_LETTERS,
  prs: PERSIAN_LETTERS,
  ar: ARABIC_LETTERS,
  zh: CHINESE_LETTERS,
  ja: JAPANESE_LETTERS,
  hi: HINDI_LETTERS,
  mr: HINDI_LETTERS,
  ne: HINDI_LETTERS,
  bn: BENGALI_LETTERS,
  ko: KOREAN_LETTERS,
  ru: CYRILLIC_LETTERS,
  uk: CYRILLIC_LETTERS,
  be: CYRILLIC_LETTERS,
  bg: CYRILLIC_LETTERS,
  kk: CYRILLIC_LETTERS,
  ky: CYRILLIC_LETTERS,
  mn: CYRILLIC_LETTERS,
  sr: CYRILLIC_LETTERS,
  mk: CYRILLIC_LETTERS,
  th: THAI_LETTERS,
  he: HEBREW_LETTERS,
  el: GREEK_LETTERS,
  en: ENGLISH_LETTERS,
};

function normalizeLanguageCode(language: string): string {
  const lang = language.trim().toLowerCase();
  if (!lang) {
    return 'en';
  }
  const dash = lang.indexOf('-');
  const underscore = lang.indexOf('_');
  const cut = [dash, underscore].filter((i) => i > 0).sort((a, b) => a - b)[0];
  return cut !== undefined ? lang.slice(0, cut) : lang;
}

export function getAlphabetForLanguage(language: string): string[] {
  const code = normalizeLanguageCode(language);
  if (ALPHABETS[code]) {
    return ALPHABETS[code];
  }
  if (LATIN_LANGUAGE_CODES.has(code)) {
    return ENGLISH_LETTERS;
  }
  return ENGLISH_LETTERS;
}
